import React from 'react';
import Grid from "@material-ui/core/Grid";

const Infotext = () => (
  <div className="Content-wrapper Content-wrapper--infotext">
    <div className="content">
      <Grid container spacing={16}>
            <Grid item xs={12} md={6}>
          <h2>Was kosten 100 US-Dollar in Euro?<br />
          Wie berechne ich den Wechselkurs zweier Währungen?<br />
            Wie hoch sind die Gebühren, wenn ich 150 Britische Pfund in Thai Baht umtausche?</h2>

          <p>
            Auf diese Fragen und viele andere mehr finden Sie bei der-waehrungsrechner.de zuverlässige Antworten. Die aktuellen Devisenkurse nahezu aller Währungen beantworten Ihre Fragen rund um das Thema Wechsel- und Devisenkurse.
          </p>

          <h2>Tagesaktuelle Kurse des Währungsrechners</h2>
          <p>Bei der-waerhungsrechner.de können Sie schnell und komfortabel den aktuellen Wechselkurs für 163 Währungen weltweit berechnen.</p>
          <p>Einfach nur die gewünschte Summe eingeben, die jeweiligen Währungen auswählen – das war's. Ob Euro, US-Dollar, Britisches Pfund, Thai Baht oder jede andere Währung, der-waehrungsrechner.de berechnet den Kurs im Handumdrehen.</p>

          <h2>Gebührenrechner</h2>
          <p>Darüberhinaus können Sie mit dem Gebührenrechner auch gleich berechnen was der Kauf einer Devise z.B. bei der Bank kosten würde, wenn Sie die jeweilige Gebühr in Prozent angeben. So haben Sie Kosten z.B. für den Kauf von Urlaubsgeld immer gleich mit im Blick. Auch Zahlungen im Ausland, beispielsweise mit der Kreditkarte und der dort typischen Gebühr von 3% für den Auslandseinsatz, lassen sich so bequem berechnen. Ebenso das Ziehen von Bargeld am Geldautomaten im Ausland, hier ist beispielhaft 2% als Gebühr vorgeschlagen.</p>
        </Grid>

        <Grid item xs={12} md={6}>
          <h2>Umrechnungstabelle</h2>
          <p>Um einen schnellen Überblick zum Verhältnis der beiden ausgewählten Währungen zueinander zu haben, gibt es zusätzlich eine sich automatisch aktualisierende Umrechnungstabelle. Hier finden Sie in üblichen Stückelungen den Umrechnungswert auf einen Blick. Auch hier werden, wenn Sie zuvor eine Gebühr in Prozent ausgewählt haben, die Kosten für einen Umtausch der jeweiligen Währung bereits mit eingerechnet.</p>

          <h2>Historische Werte</h2>
          <p>der-waehrungsrechner.de gibt Ihnen die Möglichkeit historische Werte abzurufen. Hier können Sie sich einen Überblick verschaffen, wie der Wechselkurs vor einem, fünf oder zehn Jahren war. Wählen Sie einen beliebigen historischen Wert aus, indem Sie einfach nur das Datum eingeben. Im Ergebnis können Sie so beispielsweise sehen, ob der aktuelle Kurswert einer Währung eher hoch oder eher eher niedrig im historischen Vergleich ist.</p>

          <h2>Fragen und Anregungen</h2>
          <p>Wenn Sie uns Vorschläge zu neuen Funktionalitäten für den Währungsrechner machen möchten oder Fragen zu bestimmten Themen rund um Devisen, Währungen und Umrechnungskurse haben, schicken Sie uns bitte einfach eine E-Mail an info@calmedia.de. Wir freuen uns auf Ihre Nachricht.</p>
        </Grid>
      </Grid>
    </div>
  </div>
);

export default Infotext;



// WEBPACK FOOTER //
// ./src/components/Infotext.js